// extracted by mini-css-extract-plugin
module.exports = {"MainWrap":"NewsList_MainWrap__1PqG6","NewsItem":"NewsList_NewsItem__2db89","ResourceLogo":"NewsList_ResourceLogo__35R1X"};